import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { meetSdkParamSelector, originParamSelector } from '../slices/google/selectors';
const useGoogleSdkParams = () => {
  const history = useHistory();
  const unlistenRef = useRef(undefined);
  const meetSdkParam = useSelector(meetSdkParamSelector);
  const originParam = useSelector(originParamSelector);
  useEffect(() => {
    unlistenRef.current = history.listen(location => {
      if (!location.search && meetSdkParam && originParam) {
        history.replace(`${location.pathname}?meet_sdk=${meetSdkParam}&origin=${originParam}`);
      }
    });
    return () => {
      if (unlistenRef.current) {
        unlistenRef.current();
      }
    };
  }, [history, meetSdkParam, originParam]);
  useEffect(() => {
    if (meetSdkParam && originParam && !history.location.search) {
      history.replace(`${history.location.pathname}?meet_sdk=${meetSdkParam}&origin=${originParam}`);
    }
  }, [history, meetSdkParam, originParam]);
};
export default useGoogleSdkParams;